jQuery(document).ready(function ($) {
    $('#ap-hamburger').click(function () {
       $('#my-ap-mobile-nav-menu').toggle('slow');
       $('#ap-hamburger').toggleClass("fa-bars fa-times");
    })
})
